import { render, staticRenderFns } from "./m-bean-attributes.vue?vue&type=template&id=2402eebd&"
import script from "./m-bean-attributes.vue?vue&type=script&lang=js&"
export * from "./m-bean-attributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports